// components/artifacts/renderers/TableArtifactRenderer.tsx
import React, { useMemo } from "react";
import SortableTable from "@/components/tables/SortableTable";
import { TableArtifact, TableData } from "@/types/Artifact";

interface TableArtifactRendererProps {
  artifact: TableArtifact;
}

export const TableArtifactRenderer: React.FC<TableArtifactRendererProps> = React.memo(({ 
  artifact 
}) => {
  const tableData = useMemo(() => {
    if (typeof artifact.content === "string") {
      try {
        return JSON.parse(artifact.content) as TableData;
      } catch (e) {
        console.error("Failed to parse table data:", e);
        return null;
      }
    }
    return artifact.content;
  }, [artifact.content]);

  if (!tableData) {
    return <div className="p-4 text-red-500">Invalid table data format</div>;
  }

  const { headers = [], rows = [] } = tableData;

  if (!Array.isArray(headers) || !Array.isArray(rows)) {
    return <div className="p-4 text-red-500">Invalid table structure</div>;
  }

  return (
    <div className="overflow-auto p-4">
      <SortableTable 
        headers={headers} 
        rows={rows} 
        tableIndex={0} 
      />
    </div>
  );
});